//@flow
import React from 'react';
import CookiesData from '../../Utils/cookies-data';
import UrlData from '../../Utils/url-data';
import Heap from '../../Utils/heap-interface';
import HeapActions from '../../Actions/heap';
import isEmail from 'validator/lib/isEmail';
import QuoteApi from '../../APIInterfaces/quotes';
import GlobalData from '../../Utils/globalData';
import Sailthru from '../../Utils/sailthru';
import WindowUtils from '../../Utils/window';

import type QuoteModel from '../../Stores/Quote/quoteModel';

type Props = {
  text:string,
  path?:string,
  onSubmit?:(email:string) => void,
  children?:React$Node,
  list?:string,
  placeholder?:string,
  promoCode?:string,
  quote?:QuoteModel,
  sku?:string,
  promoValidator?:() => boolean,
};

type State = {
  emailAddress:string,
  errors:boolean,
};

export default class EmailForm extends React.Component<Props, State> {
  state = { emailAddress: '', errors: false };

  getListName():?string {
    return this.props.list && GlobalData.get('sailthru', 'lists', this.props.list);
  }

  changeEmail = (event:SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      emailAddress: event.target.value,
      errors: !isEmail(event.target.value),
    });
  };

  setEmail = (e:Event) => {
    // prevent the "real" form action for all cases
    e.preventDefault();

    const email = this.state.emailAddress;
    if (!isEmail(email)) {
      this.setState({ errors: true });
      return;
    }

    CookiesData.set('email', { email });
    Heap.identify(email);
    HeapActions.trackEmailCapture({ version: 'control' });

    if (this.props.promoCode) {
      this.submitPromoCode(this.props.promoCode, email);
    }
    else if (this.props.sku) {
      this.addSkuAndSubmit(this.props.sku, email);
    }
    else {
      this.submitForm(email);
    }
  };

  submitPromoCode(promoCode:string, email:string) {
    const quoteId = this.props.quote && this.props.quote.getId();
    if (this.props.promoValidator && !this.props.promoValidator() || !quoteId) return;

    QuoteApi.setPromoCode(quoteId, promoCode)
      .onSuccess(() => this.submitForm(email));
  }

  addSkuAndSubmit(sku:string, email:string) {
    const quoteId = this.props.quote && this.props.quote.getId();
    if (!quoteId) return;

    QuoteApi.addItem(quoteId, sku)
      .onSuccess(() => this.submitForm(email));
  }

  _getErrors() {
    if (this.state.errors) return (
      <div className="form-error">This is not a valid email</div>
    );
  }

  _nextLocation = () => {
    const url = this.props.path;
    // Using window replace here because
    // because in some cases we need to push to
    // /botm route - a url that Optimizely is configured
    // to add params to, but that will only work if page is
    // reloaded (i.e. won't work with react router push)
    if (url) WindowUtils.replace(url);
  };

  submitForm(email:string) {
    if (this.props.onSubmit) {
      this.props.onSubmit(email);
    }

    const list = this.getListName();
    if (list) {
      const source = UrlData.parseUrlForKey('utm_source');
      Sailthru.userSignUp(email, list, source || 'none', this._nextLocation);
    }
  }

  render() {
    return (
      <form id="membership-option">
        <input className="email-modal-input form-control" onChange={this.changeEmail} name="email" placeholder={this.props.placeholder || 'Your email address'} id="email" type="email" value={this.state.emailAddress}/>
        {this._getErrors()}
        {this.props.children}
        <input id="email-submit" onClick={this.setEmail} className="submit-button cta" type="submit" value={`${this.props.text}`} disabled={!this.state.emailAddress || this.state.errors} />
      </form>
    );
  }
}
